



















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { auctionModule, authModule } from '@/store';
import { Bid } from '@/api';
import AbstractTable from '@/components/admin/AbstractTable.vue';

@Component({
  components: { AbstractTable },
})
export default class extends Vue {
  bids: Bid[] = [];

  page: number = 1;
  pageLen: number = 0;

  bidHeaders = [
    {
      text: 'Auction Code',
      value: 'lot.auction.code',
      width: 130,
    },
    {
      text: 'Lot Number',
      value: 'lot.number',
      width: 130,
    },
    {
      text: 'Lot',
      value: 'lot.title',
    },
    {
      text: 'Bid Amount',
      value: 'value',
      width: 150,
    },
    {
      text: 'Hammer Price',
      value: 'lot.salePrice',
      width: 150,
    },
  ];

  get bidOptions() {
    return {
      itemsPerPage: 20,
      sortBy: ['created'],
      sortDesc: [true],
    };
  }

  get bidScope() {
    return () => {
      if (!authModule.user) {
        return;
      }
      return Bid.includes(['lot.auction']).where({
        'lot.auction.status': 'past',
        user: authModule.user.id,
      });
    };
  }

  formatValue(value: number, showZeroCents: boolean = true) {
    if (!value) {
      return;
    }
    const dollarValue = value / 100;
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: showZeroCents ? 2 : 0,
    }).format(dollarValue);
  }

  async updateBids() {
    if (!authModule.user) {
      return;
    }

    try {
      const scope = Bid.includes(['lot.auction'])
        .per(12)
        .page(this.page)
        .order({ created: 'desc' })
        .where({
          'lot.auction.status': 'current',
          user: authModule.user.id,
        });
      const bids = await scope.all();
      this.pageLen = bids.meta.pagination.pages;
      this.bids = bids.data;
    } catch (err) {
      // Error
    }
  }

  async mounted() {
    if (!authModule.isLoggedIn) {
      this.$router.push({
        name: 'login',
        query: { next: window.location.pathname },
      });
    }

    this.updateBids();
  }

  @Watch('page')
  pageChanged() {
    this.updateBids();
  }
}
